/* START_MODULE_CONTRACT
 * PURPOSE: Frontend API client для админ-управления пользователями (CRUD).
 * SCOPE: HTTP-вызовы /admin/users.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, V-M-FE-API, M-ADMIN
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * getAdminUsers - список пользователей.
 * createAdminUser - создать пользователя.
 * updateAdminUser - обновить пользователя.
 * deleteAdminUser - удалить пользователя.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contracts и парные END_METHOD.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_getAdminUsers */
/* START_CONTRACT: getAdminUsers
 * PURPOSE: Получить список пользователей (admin).
 * INPUTS: { signal: AbortSignal }
 * OUTPUTS: { Promise<AxiosResponse> - GET /admin/users }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-ADMIN
 * END_CONTRACT: getAdminUsers
 */
export function getAdminUsers(signal) {
  return apiClient.get('/admin/users', { signal });
}
/* END_METHOD_getAdminUsers */

/* START_METHOD_createAdminUser */
/* START_CONTRACT: createAdminUser
 * PURPOSE: Создать пользователя (admin).
 * INPUTS: { email: string, password: string }
 * OUTPUTS: { Promise<AxiosResponse> - POST /admin/users }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-ADMIN
 * END_CONTRACT: createAdminUser
 */
export function createAdminUser({ email, password }) {
  return apiClient.post('/admin/users', { email, password });
}
/* END_METHOD_createAdminUser */

/* START_METHOD_updateAdminUser */
/* START_CONTRACT: updateAdminUser
 * PURPOSE: Обновить пользователя (admin).
 * INPUTS: { id: number|string, email: string, password: string }
 * OUTPUTS: { Promise<AxiosResponse> - PUT /admin/users/{id} }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-ADMIN
 * END_CONTRACT: updateAdminUser
 */
export function updateAdminUser(id, { email, password }) {
  return apiClient.put(`/admin/users/${id}`, { email, password });
}
/* END_METHOD_updateAdminUser */

/* START_METHOD_deleteAdminUser */
/* START_CONTRACT: deleteAdminUser
 * PURPOSE: Удалить пользователя (admin).
 * INPUTS: { id: number|string }
 * OUTPUTS: { Promise<AxiosResponse> - DELETE /admin/users/{id} }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-ADMIN
 * END_CONTRACT: deleteAdminUser
 */
export function deleteAdminUser(id) {
  return apiClient.delete(`/admin/users/${id}`);
}
/* END_METHOD_deleteAdminUser */
